<img *ngIf="image" class="vdt-media" [src]="image" alt="" decoding="async"
    [attr.loading]="eager ? null : 'lazy'" [attr.fetchpriority]="eager ? 'high' : null">
<span *ngIf="frame && !frameImage && !frameFailed" class="vdt-loading" aria-hidden="true"></span>
<img *ngIf="frameImage" class="vdt-media vdt-frame" [src]="frameImage" alt="" decoding="async">
<img *ngIf="showFallback && visible" class="vdt-media" [src]="fallback" alt="" loading="lazy" decoding="async">
